var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupSlide2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 72,
    viewBox: "0 0 108 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_180246_120622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 88,
    height: 52,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3177 23.7266C68.043 22.2311 66.9786 21.1048 65.4049 21.0137C65.4049 21.0137 63.5293 20.7729 60.2201 22.3131C59.7803 22.5178 58.0787 23.4505 57.1975 23.9778C56.8236 23.923 55.8338 23.8052 54.2296 23.8052H54.1786C50.8708 23.8105 47.9325 24.9618 45.6815 27.1352C43.4377 29.3014 41.9995 32.369 41.5221 36.006C41.4969 36.1981 41.6018 36.3839 41.7793 36.4614C41.9572 36.5391 42.1644 36.4898 42.2884 36.3407C42.5176 36.0649 45.5502 29.9098 50.6843 27.9278C45.7532 32.2892 40.5101 38.5886 40.0345 45.6176C39.5308 51.7838 44.7076 50.9638 44.7076 50.9638C48.0071 50.4672 50.0795 49.1402 52.1849 47.7821C53.1218 47.9127 54.041 47.979 54.919 47.979C60.8463 47.979 65.3206 44.9275 67.1949 39.6072C67.2418 39.4741 67.2211 39.3263 67.1397 39.2112C67.058 39.0959 66.9256 39.0274 66.7843 39.0274H58.826C58.6274 39.0274 58.4538 39.1619 58.4045 39.3544C58.0292 40.8148 56.6924 41.7224 54.9152 41.7225C53.5708 41.7225 52.3417 41.1948 51.6274 40.3107C51.0746 39.6266 50.8722 38.7627 51.0375 37.8029H67.0065C67.2392 37.8029 67.4307 37.6198 67.4412 37.3873C67.5976 33.9212 66.9321 31.1788 65.4068 29.0037C63.9528 26.9304 61.7439 25.4104 58.6639 24.3663C59.9623 23.598 62.6897 22.0934 64.8406 22.0934C65.8083 22.0934 66.5495 22.4073 67.043 23.0258C67.2557 23.2927 67.3953 23.6696 67.4581 24.146C67.488 24.3735 67.6883 24.537 67.918 24.5236C68.1468 24.5087 68.3248 24.3186 68.3248 24.0893V23.8053C68.3248 23.7789 68.3225 23.7526 68.3177 23.7266ZM45.236 49.3451C44.197 49.3451 43.4098 49.0399 42.9801 48.3806C41.6308 46.3107 43.7144 43.0147 43.7555 42.9224C45.7029 45.2813 48.0555 46.7697 50.9251 47.4575C49.5342 48.2813 47.1126 49.3451 45.236 49.3451ZM58.6745 32.9449L51.1646 32.95C51.159 32.1233 51.4388 31.3873 51.9801 30.8113C52.7042 30.0407 53.7835 29.5817 55.0179 29.5817C56.1836 29.5817 57.3096 29.987 57.9507 30.6953C58.4744 31.2738 58.7229 32.0484 58.6745 32.9449Z",
    fill: "#1976D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_180246_120622",
    x: 0,
    y: 0,
    width: 108,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.816667 0 0 0 0 0.816667 0 0 0 0 0.816667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_180246_120622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_180246_120622",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSlide2);
export default __webpack_public_path__ + "static/media/signupSlide2.1b25830127ab91e47326e6444f64858b.svg";
export { ForwardRef as ReactComponent };